import EnvironmentSettings from "../../Models/EnvironmentSettings";
import UsersApi from "../UsersApi";
import TenantManager from "../TenantManager";

class ServicesApi {
  constructor() {
    this.baseUrl =
      EnvironmentSettings.Environment === "dev"
        ? EnvironmentSettings.LocalUrl
        : EnvironmentSettings.LiveUrl;
  }

  //============================= URls ============================//
  ServicesUrl = "Services/";
  BundlesUrl = "ServiceBundles/";
  GetAllServicesUrl = "services/GetAllServices";
  CreateServiceUrl = "services/CreateService";
  DeleteServiceUrl = "services/DeleteService";
  CreateBundleUrl = "services/CreateBundle";
  GetAllBundlesUrl = "services/all";
  GetBundleDetailsUrl = "services/GetBundleDetails";
  RemoveBundleItemUrl = "services/RemoveBundleItem";
  CollectPaymentUrl = "services/PayBundleItems";
  RefundBundleUrl = "services/RefundBundle";
  UpgradeBundleUrl = "services/UpgradeBundle";
  GetNegativeBalancesUrl = "services/NegativeBalances";
  GetBundleHistoryUrl = "services/History";
  DeleteBundleUrl = "services/DeleteBundle";
  UpdateServicePriceUrl = "services/UpdateServicePrice";
  LastServiceBundleUrl = "services/LastServiceBundle";
  LinkBundleToPackageUrl = "services/LinkBundleToPackage";
  UnlinkedBundlesUrl = "services/UnlinkedBundles";
  //======================= Services Methods ======================//

  async GetAllServices(requestModel) {
    const res = await fetch(`${this.baseUrl}${this.GetAllServicesUrl}`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${await UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestModel),
    });

    return await res.json();
  }

  async CreateService(payload) {
    const res = await fetch(this.baseUrl + this.CreateServiceUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${await UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const data = await res.json();
    return data;
  }

  async DeleteService(id) {
    const res = await fetch(`${this.baseUrl}${this.DeleteServiceUrl}/${id}`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${await UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(id),
    });

    const data = await res.json();
    return data;
  }
  async UpdateServicePrice(id, newPrice) {
    const res = await fetch(`${this.baseUrl}${this.UpdateServicePriceUrl}`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${await UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id, newPrice: parseFloat(newPrice) }),
    });
    return await res.json();
  }

  //============================= Bundles Methods ============================//

  async CreateBundle(payload) {
    const res = await fetch(this.baseUrl + this.CreateBundleUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${await UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const data = await res.json();
    return data;
  }

  async GetAllBundles(requestBody) {
    const res = await fetch(`${this.baseUrl}${this.GetAllBundlesUrl}`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${await UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
    });
    return await res.json();
  }

  async GetBundleDetails(id, filters = {}) {
    const res = await fetch(
      `${this.baseUrl}${this.GetBundleDetailsUrl}/${id}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${await UsersApi.GetToken()}`,
          "Content-Type": "application/json",
          tenant: TenantManager.getTenant(await UsersApi.GetToken()),
        },
        body: JSON.stringify(filters),
      },
    );
    return await res.json();
  }

  async RemoveBundleItem(id) {
    const res = await fetch(
      `${this.baseUrl}${this.RemoveBundleItemUrl}/${id}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${await UsersApi.GetToken()}`,
          tenant: TenantManager.getTenant(await UsersApi.GetToken()),
          "Content-Type": "application/json",
        },
      },
    );
    return await res.json();
  }
  async CollectPayment(payload) {
    try {
      const res = await fetch(`${this.baseUrl}${this.CollectPaymentUrl}`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${await UsersApi.GetToken()}`,
          tenant: TenantManager.getTenant(await UsersApi.GetToken()),
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const errorData = await res.json();
        return {
          status: "Error",
          message: errorData.message || "Failed to process payment",
        };
      }

      return await res.json();
    } catch (error) {
      console.error("API Error (CollectPayment):", error);
      return { status: "Error", message: "Network connection failed" };
    }
  }
  async RefundBundle(payload) {
    const res = await fetch(`${this.baseUrl}${this.RefundBundleUrl}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${await UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(payload),
    });

    return await res.json();
  }
  async UpgradeBundle(payload) {
    const res = await fetch(`${this.baseUrl}${this.UpgradeBundleUrl}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${await UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(payload),
    });
    return await res.json();
  }

  async GetNegativeBalances() {
    const res = await fetch(`${this.baseUrl}${this.GetNegativeBalancesUrl}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${await UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
    });
    return await res.json();
  }

  async GetBundleHistory(startDate, endDate) {
    const query = new URLSearchParams({
      start: startDate,
      end: endDate,
    }).toString();
    const res = await fetch(
      `${this.baseUrl}${this.GetBundleHistoryUrl}?${query}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${await UsersApi.GetToken()}`,
          tenant: TenantManager.getTenant(await UsersApi.GetToken()),
        },
      },
    );
    return await res.json();
  }
  async DeleteBundle(id) {
    const res = await fetch(`${this.baseUrl}${this.DeleteBundleUrl}/${id}`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${await UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
        "Content-Type": "application/json",
      },
    });

    return await res.json();
  }

  async LastServiceBundle(patientId, packageId) {
    const res = await fetch(`${this.baseUrl}${this.LastServiceBundleUrl}`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${await UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ patientId, packageId }),
    });
    return await res.json();
  }

  async LinkBundleToPackage(payload) {
    const res = await fetch(`${this.baseUrl}${this.LinkBundleToPackageUrl}`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${await UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });
    return await res.json();
  }

  async GetUnlinkedBundles(patientId) {
    const res = await fetch(
      `${this.baseUrl}${this.UnlinkedBundlesUrl}/${patientId}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${await UsersApi.GetToken()}`,
          tenant: TenantManager.getTenant(await UsersApi.GetToken()),
        },
      },
    );
    return await res.json();
  }
}

export default new ServicesApi();
